let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bERdS")).then(() => parcelRequire('8ymsB'));